import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { memo, useMemo } from 'react';

const ProtectedAdminRoute = memo(({ children }) => {
  const { user, loading } = useAuth();
  
  const content = useMemo(() => {
    if (loading) {
      return <div>Yükleniyor...</div>;
    }

    if (!user || !user.is_admin) {
      return <Navigate to="/" replace />;
    }

    return children;
  }, [loading, user, children]);

  return content;
});

export default ProtectedAdminRoute; 